import React from "react";
import { Link } from "react-router-dom";

const BlogCard = ({ id,image, title,  description }) => {

  return (
    <Link to={`/blog-details/${id}`}>
      <article className="bg-white shadow-md rounded-md overflow-hidden hover:shadow-lg hover:scale-[102%] transition-all flex flex-col duration-200">
        {/* Blog Image */}
        <img
          src={image}
          alt={title}
          className="w-full h-32 sm:h-44 md:h-52 lg:h-64 object-cover object-top transition-all ease-in-out"
        />

        {/* Blog Content */}
        <div className="p-3 lg:p-5 flex flex-col flex-1 ">
          {/* <Link to={`/blog-details/${id}`}> */}
          <h3 className="text-[0.92rem] capitalize cursor-pointer sm:text-[1.08rem] md:text-[1.2rem] font-bold text-[#484848] line-clamp-2 min-h-[3rem]  mb-1 md:mb-2">
            {title}
          </h3>
          {/* </Link> */}
          {/* <p className="text-[#484848] text-[0.69rem] sm:text-[0.9rem] leading-relaxed mb-4   line-clamp-6">
            {description}
          </p> */}
          {/* <Link
          to={`/blog-details/${id}`}
          className="text-[#FF4B60] text-[0.69rem] sm:text-[1rem] font-semibold hover:underline self-end md:self-start"
        >
          READ MORE
        </Link> */}
        </div>
      </article>
    </Link>
  );
};

export default BlogCard;
